import { createSelector } from "reselect";

import { RootState } from "src/types";

/**
 * Селекторы хранилища пользователя
 */

/**
 * user
 * @param state - хранилище
 * @returns хранилище user
 */
const getRoot = (state: RootState) => state.user;

/**
 * Селектор идентификатора баланса */
export const getBalanceId = createSelector([getRoot], (root) => root.balanceId);

/**
 * Селектор контрактора
 */
export const getContractor = createSelector([getRoot], (root) => root.contractor);

/**
 * Селектор токена
 */
export const getToken = createSelector([getRoot], (root) => root.token);
